import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SlickCarouselModule } from 'ngx-slick-carousel';

@Component({
    selector: 'app-bukku-pricing-plan',
    standalone: true,
    imports: [CommonModule, TranslateModule, SlickCarouselModule],
    templateUrl: './bukku-pricing-plan.component.html',
    styleUrl: './bukku-pricing-plan.component.scss',
})
export class BukkuPricingPlanComponent {
    servicesData = [
        {
            img: 'assets/images/icons/Finance.png',
            title: 'DIGITAL_SERVICES.BUKKU.PRICING.1.TITLE',
            desc: 'DIGITAL_SERVICES.BUKKU.PRICING.1.DESC',
        },
        {
            img: 'assets/images/icons/Finance.png',
            title: 'DIGITAL_SERVICES.BUKKU.PRICING.2.TITLE',
            desc: 'DIGITAL_SERVICES.BUKKU.PRICING.2.DESC',
        },
        {
            img: 'assets/images/icons/Finance.png',
            title: 'DIGITAL_SERVICES.BUKKU.PRICING.3.TITLE',
            desc: 'DIGITAL_SERVICES.BUKKU.PRICING.3.DESC',
        },
        {
            img: 'assets/images/icons/Finance.png',
            title: 'DIGITAL_SERVICES.BUKKU.PRICING.4.TITLE',
            desc: 'DIGITAL_SERVICES.BUKKU.PRICING.4.DESC',
        },
        {
            img: 'assets/images/icons/Finance.png',
            title: 'DIGITAL_SERVICES.BUKKU.PRICING.5.TITLE',
            desc: 'DIGITAL_SERVICES.BUKKU.PRICING.5.DESC',
        },
    ];

    slideConfig = {
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        centerMode: false,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                    centerMode: false,
                    infinite: false,
                },
            },
        ],
    };
}
